import React from 'react';
import PropTypes from 'prop-types';

import useDispatch from 'client/hooks/useDispatch';

import requestUtilityApi from 'client/actions/requestUtilityApi';
import { SR_API_ACTION_UTILITY_ACTIVATION_UPDATE_ITEM } from 'api/utilityActionTypes';
import { UTILITY_ACTIVATION_ITEM_DROPOUT_REASON_PARTNER_MARKED_PURCHASED_OUTSIDE } from 'common/utility/constants';

import SrBox from 'client/components/SrBox';
import SrText from 'client/components/SrText';
import SrSimpleMessageModal, {
  SR_SIMPLE_MESSAGE_MODAL_THEME_SLIDE_UP,
} from 'client/components/SrSimpleMessageModal/SrSimpleMessageModal';
import {
  SR_BUTTON_THEME_ADOBE_GREY,
  SR_BUTTON_THEME_ADOBE_YELLOW,
} from 'client/components/SrButton/SrButton';

const SrUtilityActivationInternetPurchasedOutsideModal = ({
  utilityActivationItem,
  onSubmitCallback,
  onClose,
}) => {
  const dispatch = useDispatch();

  const onConfirm = () => {
    return dispatch(requestUtilityApi, {
      action: SR_API_ACTION_UTILITY_ACTIVATION_UPDATE_ITEM,
      payload: {
        id: utilityActivationItem.id,
        updates: {
          dropoutReason: UTILITY_ACTIVATION_ITEM_DROPOUT_REASON_PARTNER_MARKED_PURCHASED_OUTSIDE,
        },
      },
    }).then(() => {
      if (onSubmitCallback) {
        return onSubmitCallback();
      }
      onClose();
    });
  };

  return (
    <SrSimpleMessageModal
      theme={SR_SIMPLE_MESSAGE_MODAL_THEME_SLIDE_UP}
      iconUrl="/images/question-mark.svg"
      maxIconHeight="50px"
      maxIconWidth="50px"
      contentContainerClassName="utilityProviderContact"
      iconBgColor="#FFFBEB"
      maxWidth="375"
      headline={
        <SrBox>
          <SrText font="greycliff" weight="800" fontSize="25px" lineHeight="25px">
            Confirm that the tenant <u>did not</u> purchase internet using Utility Profit?
          </SrText>
        </SrBox>
      }
      underline
      message={
        <SrBox>
          <SrText font="greycliff" weight="600" fontSize="16px" lineHeight="19px" align="center">
            This adds a “green check” to the utility, but also prevents you from making any revenue
            from this utility.
          </SrText>
        </SrBox>
      }
      srMultiButtons={[
        {
          buttonText: 'Purchased outside of this tool',
          onButtonClick: onConfirm,
          buttonTheme: SR_BUTTON_THEME_ADOBE_YELLOW,
        },
        {
          buttonText: 'Cancel',
          onButtonClick: onClose,
          buttonTheme: SR_BUTTON_THEME_ADOBE_GREY,
        },
      ]}
    />
  );
};

SrUtilityActivationInternetPurchasedOutsideModal.propTypes = {
  utilityActivationItem: PropTypes.object.isRequired,
  onSubmitCallback: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
};

SrUtilityActivationInternetPurchasedOutsideModal.displayName =
  'SrUtilityActivationInternetPurchasedOutsideModal'; // eslint-disable-line max-len

export default SrUtilityActivationInternetPurchasedOutsideModal;
